import { useEffect } from 'react';

const OG_TAGS = [
  ['property', 'og:title'],
  ['property', 'og:description'],
  ['property', 'og:image'],
  ['property', 'og:url'],
  ['property', 'og:site_name'],
  ['name', 'twitter:title'],
  ['name', 'twitter:description'],
  ['name', 'twitter:image'],
  ['name', 'twitter:card'],
  ['name', 'description'],
];

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function absoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const base = (import.meta.env.VITE_PUBLIC_SITE_URL || '').replace(/\/$/, '');
  if (base) return `${base}${pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`}`;
  if (typeof window !== 'undefined') {
    return new URL(pathOrUrl, window.location.origin).href;
  }
  return pathOrUrl;
}

/**
 * Met à jour title + meta description / Open Graph / Twitter pour la route courante.
 * @param {{
 *   title?: string,
 *   description?: string,
 *   image?: string,
 *   path?: string,
 * }} props
 */
export default function DocumentMeta({ title, description, image = '/og-share.svg', path }) {
  useEffect(() => {
    if (title) document.title = title;

    const ogImage = absoluteUrl(image);
    const ogUrl = absoluteUrl(path || (typeof window !== 'undefined' ? window.location.pathname : '/'));

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:url', ogUrl);
    upsertMeta('property', 'og:site_name', 'Happy Paws');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);
  }, [title, description, image, path]);

  return null;
}

export { upsertMeta, absoluteUrl, OG_TAGS };
